exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#settings #social-link-settings .select-list > div {\n  flex: 1;\n  color: #aaa;\n  border-radius: 200px;\n}\n#settings #social-link-settings .select-list > div > a {\n  font-size: 17px;\n  padding: 15px 39px 21px 15px;\n}\n", ""]);

// exports
